import api from './en.api.ts';
import common from './en.common.ts';

export default {
  page: {
    priceCalculator: {
      companyName: 'Company Name',
      email: 'E-Mail',
      headline: 'Price Calculator',
      title: 'Price Calculator',
      sites: 'Sites',
      assets: 'Assets',
      displayName: 'Name',
      description: 'Description',
      assetType: 'Asset Type',
      customerType: 'Customer Type',
      deploymentType: 'Deployment Type',
      applicationType: 'Application Type',
      moduleType: 'Module Type',
      min: 'Min',
      max: 'Max',
      price: 'Price',
      status: 'Status',
      panels: {
        company: 'Company',
        sites: 'Sites',
        site: 'Site {0}',
        license: 'License',
        module: 'Module | Modules',
        price: 'Price | Prices',
        contact: 'Contact | Contacts',
        project: 'Project | Projects',
        deployment: 'Deployment | Deployments',
        application: 'Application | Applications',
        duration: 'Duration | Durations',
        calculation: 'Calculation | Calculations',
        environment: 'Environment | Environments',
      },
      form: {
        company: {
          customerType: 'Customer Type',
          customerAge: 'Customer Age (years)',
        },
        project: {
          projectType: 'Project type',
          currency: 'Currency',
        },
        license: {
          license: 'License',
          model: 'License Model',
          status: 'Status',
          duration: 'Duration',
          individualPurchase: 'Individual Purchase',
          ssa: 'Service Agreement',
        },
        site: {
          displayName: 'Name',
          description: 'Description',
        },
        asset: 'Asset | Assets',
      },
      duration: '{0} Years',
    },
    companies: {
      showCalculation: 'Show Calculation | Show Calculations ({0})',
      errors: {
        noCompany: 'No company selected',
        updateCompany: 'An error occurred while updating the company',
        createCompany: 'An error occurred while creating the company',
      },
    },
  },

  common,
  api,
};
